<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="columns"
      :data="mailboxData"
      style="width: 100.1%;"
    >
      <template slot-scope="{ row, index }" slot="delete"></template>
    </Table>
    <!-- 操作日志详情 -->
    <configuration-management-operation-log
      v-if="isShowOperationLog"
      ref="configurationManagementOperationLog"
    ></configuration-management-operation-log>
    <Modal v-model="mailboxDelmodal" width="360" :mask-closable="false">
      <p slot="header" style="color:#f60;text-align:center">
        <Icon type="ios-information-circle"></Icon>
        <span>{{ $t("alarms.common.deleteConfirmation") }}</span>
      </p>
      <div style="text-align:center">
        <p>
          {{ $t("alarms.common.sureDelete") }} {{ mailboxName }}
          {{ $t("alarms.common.what") }}?
        </p>
      </div>
      <div slot="footer">
        <Button
          type="error"
          size="large"
          long
          :loading="modal_loading"
          @click="removeMailbox()"
          :disabled="isDisable"
          >{{ $t("common.del") }}</Button
        >
      </div>
    </Modal>
    <!-- 编辑账户模式框 -->
    <div v-if="showMailboxsModal">
      <edit-mailboxs
        @on-close-cancel="onCloseCancel"
        :mailboxsEditOldForm="mailboxsEditForm"
      ></edit-mailboxs>
    </div>
    <!-- :page-size-opts="[2,4,6,8]" -->
    <Page
      :current="current"
      :total="dataTotal"
      show-sizer
      :page-size="pageSize"
      @on-change="changePage"
      @on-page-size-change="changeSize"
      :transfer="true"
    ></Page>
  </div>
</template>
<script>
import EditMailboxs from "./EditMailboxs.vue";
import ConfigurationManagementOperationLog from "../../common/ConfigurationManagementOperationLog.vue";

var tableMailboxsVue = {};
export default {
  name: "TableMailboxs",
  components: {
    EditMailboxs,
    ConfigurationManagementOperationLog
  },
  data() {
    return {
      isShowOperationLog: false,
      mailboxsEditForm: {},
      val: "",
      showList: [],
      dataTotal: 0,
      showMailboxsModal: false,
      lineIndex: 0,
      mailboxName: "",
      isDisable: false,
      current: 1,
      pageSize: 10,
      mailboxDelmodal: false,
      modal_loading: false,
      columns: [
        {
          title: this.$t(
            "configuration_management.mailbox_management.emailName"
          ),
          key: "name",
          render: (h, params) => {
            return h(
              "a",
              {
                style: {
                  textDecoration: "underline"
                },
                on: {
                  click: () => {
                    this.showMailboxsModal = true;
                    this.mailboxsEditForm = params.row;
                    this.$emit("on-open-modal");
                  }
                }
              },
              params.row.name
            );
          }
        },
        {
          title: this.$t("configuration_management.mailbox_management.host"),
          key: "host"
        },
        {
          title: this.$t("configuration_management.mailbox_management.port"),
          key: "port"
        },
        {
          title: this.$t(
            "configuration_management.mailbox_management.userName"
          ),
          key: "userName"
        },
        {
          title: this.$t(
            "configuration_management.mailbox_management.describe"
          ),
          key: "description"
        },
        {
          title: this.$t("common.del"),
          slot: "delete",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "success",
                    size: "small"
                  },
                  on: {
                    click: () => {
                      this.rowClick(params.row);
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:monitorMailboxConfiguration:log"
                      )
                    }
                  ]
                },
                this.$t("common.operationLog")
              ),
              h("span", {}, " "),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small",
                    disabled: params.row.flag === false
                  },
                  on: {
                    click: () => {
                      this.doDelete(params.index);
                      this.mailboxDelmodal = true;
                    }
                  },
                  directives: [
                    {
                      name: "hasPermission",
                      value: new Array(
                        "configurationManagement:monitorMailboxConfiguration:delete"
                      )
                    }
                  ] //  value值为SQL中的code值
                },
                this.$t("common.del")
              )
            ]);
          }
        }
      ],
      mailboxData: []
    };
  },
  beforeCreate: function() {
    tableMailboxsVue = this;
  },
  mounted: function() {
    tableMailboxsVue.getMailboxsData();
  },
  methods: {
    showAll: function() {
      tableMailboxsVue.getMailboxsData();
    },
    doDelete: function(index) {
      this.lineIndex = index;
      this.mailboxName = this.mailboxData[index].name;
    },
    getMailboxsData: function() {
      // 获取MailboxsSearch里面的搜索内容
      eventBus.$on("mailboxSearchName", function(val) {
        tableMailboxsVue.val = val;
      });
      //日程列表分页
      tableMailboxsVue.$api.mailbox
        .page({
          name: tableMailboxsVue.val,
          pageNum: this.current,
          pageSize: this.pageSize
        })
        .then(res => {
          this.mailboxData = res.data.records;
          this.current = res.data.current;
          this.dataTotal = res.data.total;
        });
    },
    changePage: function(current) {
      this.current = current;
      tableMailboxsVue.getMailboxsData();
    },
    changeSize: function(pageSize) {
      this.pageSize = pageSize;
      tableMailboxsVue.getMailboxsData();
    },
    // 删除
    removeMailbox: function() {
      this.isDisable = true; //开始可以点击
      var lineIndex = this.lineIndex;
      //日程删除
      this.$api.mailbox
        .delete("id", this.mailboxData[lineIndex].id)
        .then(res => {
          this.modal_loading = true;
          setTimeout(() => {
            // 最后一页全部删除 显示前一页(当前页为最后一页，如何判断？当前页-1*每页数=总数)
            //21条  3页  2*10+1时删除
            if (
              lineIndex == 0 &&
              (this.current - 1) * this.pageSize + 1 == this.dataTotal
            ) {
              this.current = this.current - 1;
            }
            this.dataTotal = this.dataTotal - 1;
            tableMailboxsVue.getMailboxsData();
            this.isDisable = false;
            this.modal_loading = false;
            this.mailboxDelmodal = false;
            this.$Message.success(this.$t("common.deleteSuccess"));
          }, 1000);
        });
    },
    // 销毁mailboxSearchName
    beforeDestroy: function() {
      eventBus.$off("mailboxSearchName");
    },
    onCloseCancel(bool) {
      this.showMailboxsModal = bool;
    },
    // 操作日志
    rowClick: function(row) {
      this.isShowOperationLog = true;
      this.$nextTick(function() {
        this.$refs.configurationManagementOperationLog.getConfigurationManagementOperationLogList(
          row.id,
          5
        );
      });
    }
  }
};
</script>
<style scoped>
.ivu-page {
  margin-top: 10px !important;
  margin-bottom: 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/configuration_management/monitor_mailbox_configuration/TableMailboxs.vue